import { createSlice } from '@reduxjs/toolkit';
import { PACS_URL } from '@custom/constant';

const initialState = {
  showSelectionCheckbox: false,
  selectedImages: [],
}

const convertToWadorsUrl = (inputString) => {
  const regex = /studies-(.+?)-series-(.+?)-instances-(.+?)-frames-(\d+)\.png/;
  const match = inputString.match(regex);

  if (match) {
    const [ , studyId, seriesId, instanceId, frameId ] = match;
    return `wadors:${PACS_URL}/dcm4chee-arc/aets/DCM4CHEE/rs/studies/${studyId}/series/${seriesId}/instances/${instanceId}/frames/${frameId}`;
  }
  return null;
};

const reportImageSelectionSlice = createSlice({
  name: 'report/imageSelection',
  initialState,
  reducers: {
    toggleSelectionCheckbox: (state, {payload}): void => {
      state.showSelectionCheckbox = payload;
      // state.selectedImages.length = 0;
    },
    addImage: (state, {payload}): void => {
      state?.selectedImages?.push(payload);
    },
    removeImage: (state, {payload}): void => {
      const temp = state?.selectedImages?.filter(image => image.imgName !== payload);
      state.selectedImages = temp;
    },
    setSelectedImages: (state, {payload}) => {
      if(payload){
        state.selectedImages = payload?.map((item)=>{
          return {imgName: convertToWadorsUrl(item), imgData: item};
        });
      }
    }
  },
});

export const { addImage, removeImage, toggleSelectionCheckbox, setSelectedImages } = reportImageSelectionSlice.actions;
export default reportImageSelectionSlice.reducer;
